<div>
  <mat-paginator *ngIf="paginator" #paginator [pageSize]="10" [pageSizeOptions]="[5, 10, 20]" [length]="reportservice.dataLength" (page)="changePage($event)"></mat-paginator>
  <table mat-table matSort [dataSource]="datasource" class="report-table">
      <ng-container matColumnDef="report">
          <th mat-header-cell *matHeaderCellDef style="display: none;"></th>
          <td mat-cell *matCellDef="let report">
              <div class="flex-container" fxLayout="row" fxLayoutGap="5px" fxLayout.lt-sm="column">
                <div *ngIf="selectable" fxFlex="32px">
                    <mat-checkbox [checked]="isChecked(report.id)" (change)="toggle(report.id,$event.checked)"></mat-checkbox>
                </div>
                <div fxFlex>
                    <app-report-row [item]="report"></app-report-row>
                </div>
              </div>
          </td>
      </ng-container>
      <tr class="hide-header" mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
  </table>
</div>
